import React, {Fragment} from "react";
import { Row, Col, Card, CardBody, CardTitle, Container } from "reactstrap";
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import requestApi from "../../../services/requestApi.service";
import { toperReports } from "../Constants"; 

class ToperReports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData : []
        }
    }

    componentDidMount(){
        //this.getToperReports();
        const {data} = this.props;
        this.setState({formData : data});
    }

    getToperReports = async () => {
        let {formname, dateFilter, filterTxt} = this.props;
        if(Object.keys(filterTxt).length > 0){
            let filterOption = [dateFilter,filterTxt];
            let neededFilters = [
                {'dateFilter' : true},
                {'users' : true},
                {'type' : false},
            ];
            
            let params = {
                "ENTITY": "MOBILE_PROCESS",
                "OPERATION": "GET_TOPER_REPORTS",
                "FORMNAME": formname,
                "isOtherApiReq" : true,
                "FILTEROPTION" : filterOption,
                "NEEDEDFILTERS" : neededFilters,
            };
            let response = await requestApi.processServerRequest(params);
            if(response.issuccess){
                let data = response.data;
                this.setState({
                    formData : data,
                })
            }
        }
    }

    render(){
        let {formData} = this.state;

        return(
            <div>
                <Fragment>
                    <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                            timeout={0} enter={false} exit={false}>
                            <Container fluid>
                                <Card className="main-card mb-3">
                                    <Row>
                                        {
                                            toperReports.map((val, val_index) => {
                                                return(
                                                    <>
                                                        <Col lg="4">
                                                            <Card className="main-card mb-3">
                                                                <CardBody>
                                                                    <CardTitle>
                                                                        <div className="caller-widget-header">
                                                                            <h4 className="caller-widget-header4">{val.label}</h4>
                                                                        </div>
                                                                    </CardTitle>    
                                                                        {
                                                                            val.data.map((value, value_ind) => {
                                                                                let content = formData[val_index] && formData[val_index][value_ind] ? formData[val_index][value_ind] : '-';
                                                                                return(
                                                                                    <>
                                                                                    <div className="caller-widget-box">
                                                                                        <span className="caller-widget-box-header2">{value.header}</span>
                                                                                        <p  className="caller-widget-box-p">{content[0] !== undefined ? content[0] : '-'}</p>
                                                                                        {
                                                                                            value.body !== undefined && value.body.map((field,field_ind) => {
                                                                                                return(
                                                                                                    <>
                                                                                                        <h3 className="caller-widget-box-header3">
                                                                                                            {content[field_ind + 1] ? field.fields + content[field_ind + 1] : field.fields + 0}
                                                                                                        </h3>
                                                                                                    </>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                    </>
                                                                                )
                                                                            })
                                                                        }
                                                                <p className="caller-widget-box-msg">{val.desc} </p>
                                                                </CardBody>
                                                            </Card>
                                                        </Col> 
                                                    </>
                                                )
                                            })
                                        }                           
                                    </Row>
                                </Card>
                            </Container>
                        </CSSTransition>
                </Fragment>
            </div>
        )
    }

}

export default ToperReports;
